import getLeadsReportsFilters from './leadsReportsFilters';
import getMyListingsFilters from './listingFilters';

export default {
  getLeadsReportsFilters,
  getMyListingsFilters,
};
